<div class="buttons-container" *ngIf="config" [ngClass]="{ 'space-between-back-button': orderStatus === null }">
  <button
    *ngIf="orderStatus === null"
    class="back-button"
    id="order-confirm-back"
    data-action="order-confirm-back"
    mat-stroked-button
    color="secondary"
    (click)="goBack()"
  >
    {{ 'COMMON.ACTION_LABELS.BACK' | translate }}
  </button>

  <div class="buttons-wrapper">
    <!-- Secondary actions -->
    <ng-container [ngSwitch]="orderStatus">
      <ng-container *ngSwitchCase="status.SUBMITTED">
        <button
          class="secondary-button"
          mat-stroked-button
          data-action="order-confirm-cancel"
          (click)="onIntentToCancel()"
        >
          {{ 'COMMON.ORDERS.CANCEL_ORDER' | translate }}
        </button>
      </ng-container>
      <ng-container *ngSwitchCase="status.SUBMITTED_FOR_CUSTOMER_APPROVAL">
        <button
          class="secondary-button"
          mat-stroked-button
          data-action="order-confirm-cancel"
          (click)="onIntentToCancel()"
        >
          {{ 'COMMON.ORDERS.CANCEL_ORDER' | translate }}
        </button>
      </ng-container>
      <ng-container *ngSwitchCase="status.APPROVED">
        <button
          class="secondary-button"
          mat-stroked-button
          data-action="order-confirm-cancel"
          (click)="onIntentToCancel()"
        >
          {{ 'COMMON.ORDERS.CANCEL_ORDER' | translate }}
        </button>
      </ng-container>
      <ng-container *ngSwitchCase="status.ARCHIVED">
        <button
          class="secondary-button"
          mat-stroked-button
          data-action="order-confirm-cancel"
          (click)="onIntentToCancel()"
        >
          {{ 'COMMON.ORDERS.CANCEL_ORDER' | translate }}
        </button>
      </ng-container>
    </ng-container>

    <ng-container [ngSwitch]="orderStatus">
      <ng-container *ngSwitchCase="null">
        <button
          class="secondary-button"
          id="order-confirm-draft"
          data-action="order-confirm-draft"
          mat-stroked-button
          (click)="createDraftOrder()"
        >
          {{ 'COMMON.ORDERS.DRAFT_ORDER' | translate }}
        </button>
        <ng-container *ngIf="!config.leaseToAutomations">
          <ng-container *ngTemplateOutlet="draftButtons"></ng-container>
        </ng-container>
        <ng-container *ngIf="config.leaseToAutomations">
          <button
            id="order-confirm-submit-c4"
            data-action="order-confirm-submit"
            mat-flat-button
            color="primary"
            class="primary-button"
            [disabled]="submitDisabled"
            (click)="leaseOrderToAutomations()"
          >
            {{ 'COMMON.ORDERS.SUBMIT_ORDER' | translate }}
          </button>
        </ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="status.DRAFTED">
        <ng-container *ngIf="!config.leaseToAutomations">
          <ng-container *ngTemplateOutlet="draftButtons"></ng-container>
        </ng-container>
        <!-- case 4 -->
        <ng-container *ngIf="config.leaseToAutomations">
          <button
            data-action="order-confirm-submit"
            mat-flat-button
            color="primary"
            class="primary-button"
            [disabled]="submitDisabled"
            (click)="leaseOrderToAutomations()"
          >
            {{ 'COMMON.ORDERS.SUBMIT_ORDER' | translate }}
          </button>
        </ng-container>
        <!-- END: case 4 -->
      </ng-container>
      <ng-container *ngSwitchCase="status.RESUBMITTED">
        <button mat-flat-button color="primary" (click)="onIntentToCancel()">
          {{ 'COMMON.ORDERS.CANCEL_ORDER' | translate }}
        </button>
      </ng-container>
      <ng-container *ngSwitchCase="status.ACTIVATION_ERRORS">
        <button mat-flat-button color="primary" (click)="onIntentToCancel()">
          {{ 'COMMON.ORDERS.CANCEL_ORDER' | translate }}
        </button>
      </ng-container>
      <ng-container *ngSwitchCase="status.SCHEDULED_ACTIVATION">
        <button mat-flat-button color="primary" (click)="onIntentToCancel()">
          {{ 'COMMON.ORDERS.CANCEL_ORDER' | translate }}
        </button>
      </ng-container>
      <ng-container *ngSwitchCase="status.FULFILLED">
        <button mat-flat-button color="primary" (click)="onIntentToCancel()">
          {{ 'COMMON.ORDERS.CANCEL_ORDER' | translate }}
        </button>
      </ng-container>
      <ng-container *ngSwitchCase="status.SUBMITTED_FOR_CUSTOMER_APPROVAL">
        <button
          mat-flat-button
          color="primary"
          *ngIf="config.allowSendToCustomer"
          (click)="submitForCustomerApproval()"
        >
          {{ 'COMMON.ORDERS.RESUBMIT_FOR_CUSTOMER_APPROVAL' | translate }}
        </button>
      </ng-container>
      <ng-container *ngSwitchCase="status.ARCHIVED">
        <button mat-flat-button color="primary" (click)="onConvertToDraft()">
          {{ 'COMMON.ORDERS.CONVERT_TO_DRAFT' | translate }}
        </button>
      </ng-container>
      <ng-container *ngSwitchCase="status.DECLINED">
        <button mat-flat-button color="primary" (click)="onConvertToDraft()">
          {{ 'COMMON.ORDERS.CONVERT_TO_DRAFT' | translate }}
        </button>
      </ng-container>
    </ng-container>
  </div>
</div>

<ng-template #draftButtons>
  <glxy-button-group class="navigation-button-group">
    <ng-container *ngIf="draftActionButtons.length > 0">
      <button
        [id]="draftActionButtons[0].id"
        [attr.data-action]="draftActionButtons[0].dataAction"
        mat-flat-button
        color="primary"
        class="primary-button"
        [disabled]="submitDisabled"
        (click)="draftActionButtons[0].action()"
      >
        {{ draftActionButtons[0].label }}
      </button>
    </ng-container>
    <ng-container *ngIf="draftActionButtons.length > 1">
      <button
        id="order-confirm-menu-c1"
        class="dropdown-icon"
        mat-flat-button
        color="primary"
        [disabled]="submitDisabled"
        [matMenuTriggerFor]="submitMenu1"
      >
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
      <mat-menu #submitMenu1="matMenu">
        <ng-container *ngFor="let actionButton of draftActionButtons; let first = first">
          <!-- we already rendered the first button above, don't do it again -->
          <ng-container *ngIf="!first">
            <button
              [id]="actionButton.id"
              [attr.data-action]="actionButton.dataAction"
              mat-menu-item
              (click)="actionButton.action()"
            >
              {{ actionButton.label }}
            </button>
          </ng-container>
        </ng-container>
      </mat-menu>
    </ng-container>
  </glxy-button-group>
</ng-template>
